module.exports = __webpack_public_path__ + "img/W-f-f-1.2.9e24c714.jpg";